import React from 'react';
import { SideNav } from 'app-components';

const onNavClick = (e?: React.MouseEvent<HTMLElement> | null) => {
    e?.preventDefault();
};

const SidebarBottom = () => {

    return (
        <SideNav>
            <SideNav.Header labelId="dynamicSecurityQuestion.process" />
            <SideNav.ActionLink
                isSelectedDefault={true}
                labelId="dynamicSecurityQuestion.securityQuestions"
                onClickHandler={onNavClick}
            />
        </SideNav>
    );
};

export default SidebarBottom;
